import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ReferralPageComponent } from './referral.page';

const routes: Routes = [
  {
    component: ReferralPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ReferralPageRoutingModule {}
